// External-Dependencies
import { isUndefined, pickBy } from 'lodash';

// WP-Dependencies
import { Component } from '@wordpress/element';
import { PanelBody, SelectControl, RangeControl, ToggleControl, TextControl } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';
import { InspectorControls } from '@wordpress/block-editor';
import { decodeEntities } from '@wordpress/html-entities';

//Constants
import {
	MIN_EXCERPT_LENGTH,
	MAX_EXCERPT_LENGTH,
	MAX_POSTS_COLUMNS,
} from './constants';

//"GLOBALS"
const CATEGORIES_LIST_QUERY = {	per_page: -1 };
var activeCategory = [];


export default class LatestPostsMasonryEdit extends Component {

	constructor() {
		super( ...arguments );
		this.state = {
			categoriesList: [],
			eventCatList: [],
			postCount: 3
		};
	}

	componentDidMount() {
		this.isStillMounted = true;
		this.fetchRequest = apiFetch( {
			path: addQueryArgs( `/wp/v2/categories`, CATEGORIES_LIST_QUERY ),
		} )
			.then( ( categoriesList ) => {
				if ( this.isStillMounted ) {

					this.setState( { categoriesList } );
				}
			} )
			.catch( () => {
				if ( this.isStillMounted ) {
					this.setState( { categoriesList: [] } );
				}
			} );
                
		this.fetchEventCats = apiFetch( {
			path: addQueryArgs( `/wp/v2/tribe_events_cat`, CATEGORIES_LIST_QUERY ),
		} )
			.then( ( eventCatList ) => {
				if ( this.isStillMounted ) {

					this.setState( { eventCatList } );
				}
			} )
			.catch( () => {
				if ( this.isStillMounted ) {
					this.setState( { eventCatList: [] } );
				}
			} );
	}

	componentWillUnmount() {
		this.isStillMounted = false;
	}

	render() {

		const {
			attributes,
			setAttributes,
			latestPosts,
		} = this.props;

		const { categoriesList, eventCatList } = this.state;

		const {
			displayPostContentRadio,
			displayPostContent,
			displayPostDate,
			postLayout,
			columns,
			order,
			orderBy,
			categories,
			eventCategories,
			postsToShow,
			excerptLength,
			count,
			showFilter,
			useAjax,
                        showTitel,
                        titel,
                        titelMarkup,
		} = attributes;

		const getCats = () => {

			var myCats = categoriesList.map( function (item) {
				// console.log(item);
				var composedObj = {value: item['id'], label: item['name']};
				return composedObj;
			});

			return myCats;
		};

		const getEventCats = () => {
			// console.log(eventCatList);
			var myCats = eventCatList.map( function (item) {
//                                console.log(item);
				var composedObj = {value: item['id'], label: item['name']};
				return composedObj;
			});

			return myCats;
		};

		const setCategory = (value) => {
//			console.log(value);

			setAttributes( { categories: value } );
		};

		const setEventCategory = (value) => {
//			console.log(value);
			setAttributes( { eventCategories: value } );
		};

		const setOrder = (value) => {

			setAttributes( { order: value } );
		}

		const setOrderBy = (value) => {

			setAttributes( { orderBy: value } );
		}

		const setCount = (value) => {

			setAttributes( { count: value } );
		}

		const setFilter = (value) => {

			setAttributes( { showFilter: value } );
		}
		const setAjax = (value) => {

			setAttributes( { useAjax: value } );
		}
                
                const setShowTitel = (value) => {

			setAttributes( { showTitel: value } );
		}
                
                const setTitel = (value) => {

			setAttributes( { titel: value } );
		}
                
                const setTitelMarkup = (value) => {

			setAttributes( { titelMarkup: value } );
		}

		const inspectorControls = (
			<InspectorControls>
				
				<PanelBody title="Kategorie Einstellungen">

					<SelectControl
						multiple
						label = { 'Kategorien auswählen:' }
						value = { categories }
						onChange = { setCategory }
						options = { getCats() }
					/>


					<SelectControl
						multiple
						label = { 'Event Kategorien auswählen:' }
						value = { eventCategories }
						onChange = { setEventCategory }
						options = { getEventCats() }
					/>

					<SelectControl
						label = { 'Reihenfolge:' }
						value = { order }
						onChange = { setOrder }
						options = { [
							{value: 'desc', label: "Absteigend"},
							{value: 'asc', label: "Aufsteigend"}
							] }
					/>

					<SelectControl
						label = { 'Sortierung:' }
						value = { orderBy }
						onChange = { setOrderBy }
						options = { [
							{value: 'none', label: "keine"},
							{value: 'name', label: "Name"},
							{value: 'author', label: "Autor"},
							{value: 'date', label: "Datum"},
							{value: 'title', label: "Titel"},
							{value: 'modified', label: "Geändert"},
							{value: 'rand', label: "Zufall"},
							{value: 'relevance', label: "Relevanz"}
							] }
					/>

					<RangeControl
				        label="Anzahl Posts"
				        value={ count }
				        onChange={ setCount }
				        min={ 3 }
				        max={ 12 }
				    />

				</PanelBody>
                                
                                <PanelBody title="Titel Einstellungen">
			    	
			    	<ToggleControl
				        label= {"Titel anzeigen"}
				        help={ showFilter ? 'Titel anzeigen.' : 'Titel ausblenden.' }
				        checked={ showTitel }
				        onChange={ setShowTitel }
                                />
                                
                                <SelectControl
                                    label= {"Tag in den der Titel gesetzt wird."}
                                    value={ titelMarkup }
                                    options = {[
                                        {label: "H1", value: 'h1'},
                                        {label: "H2", value: 'h2'},
                                        {label: "H3", value: 'h3'},
                                        {label: "H4", value: 'h4'},
                                    ]}
                                    onChange = { setTitelMarkup }
                                />

                                <TextControl
                                    label={"Titel"}
                                    help={ 'Titel der neben der Filterleiste angezeigt werden soll.' }
                                    value={ titel }
                                    onChange={ setTitel }
                                />

                            </PanelBody>
                                
			    <PanelBody title="Filter Einstellungen">
			    	
			    	<ToggleControl
				        label= {"Filter anzeigen"}
				        help={ showFilter ? 'Filter an.' : 'Filter aus.' }
				        checked={ showFilter }
				        onChange={ setFilter }
				    />

				    <ToggleControl
				        label={"Mehr laden anzeigen"}
				        help={ useAjax ? 'Mehr an.' : 'Mehr aus.' }
				        checked={ useAjax }
				        onChange={ setAjax }
				    />

				</PanelBody>
			</InspectorControls>
			);

		return (

			<React.Fragment>
				{inspectorControls}
				<p>
					<strong>GTÜ - Masonry Kategorieliste</strong><br/>
				</p>
			</React.Fragment>
		);
	}
}





